const ADMIN_BASE = '/admin';
/**
 * Path under the main SPA for admin screens (e.g. /admin/dashboard).
 */
export function adminPath(segment) {
    const raw = segment.startsWith('/') ? segment.slice(1) : segment;
    const tail = raw || 'dashboard';
    return `${ADMIN_BASE}/${tail}`;
}
export function navigateToAdmin(navigate, segment) {
    navigate(adminPath(segment));
}
export function shouldHideMainFooter(pathname) {
    return pathname.startsWith(ADMIN_BASE);
}
